import { addDoc, collection, deleteDoc, getDoc, getDocs, getFirestore, orderBy, query, serverTimestamp, where } from 'firebase/firestore';
import React, { useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';
import { DEBUG, enablePromise, openDatabase } from 'react-native-sqlite-storage';
import { branch, companyDir } from './StockAwareTempData';

interface ChartData {
  value: number;
  color: string;
};
interface AxisData {
  value: number;
  month: string;
  day: string;
};

interface BorderWidth {
  brdWdth?: number
}

export const AdvancedCustomBar: React.FC<BorderWidth> = ({brdWdth = 2})=>{
  const monthNames = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  const dataSet: ChartData[] = []
  const [dateArray, setDateArray] = useState<string[]>([]);
  const array: AxisData[] = []
  const yAxisItems = [];
  const [correctDateTime, setCorrectDateTime] = useState([])
  
  const [data, setData] = useState<ChartData[]>
  ([
    { value: 0, color: 'red' },
    { value: 0, color: 'blue' },
    { value: 0, color: 'green' },
    { value: 0, color: 'orange' },
    { value: 0, color: 'purple' },
    { value: 0, color: 'yellow' },
    { value: 0, color: 'pink' },
  ]);
  
  const colors = [
    { color: '#2A6AA7'},
    { color: '#BF2321' },
    { color: 'green' },
    { color: 'orange' },
    { color: 'purple' },
    { color: '#49ADD8' },
    { color: '#2a2d3e' },
  ];

  function getOrdinalSuffix(number: number): string {
    if (number >= 11 && number <= 13) {
      return number + 'th';
    } else {
      const lastDigit = number % 10;
      switch (lastDigit) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
        default:
          return number + 'th';
      }
    }
  }

  function formatNumber(number: number): string {
    const abbreviations: { [key: string]: number } = {
      t: 1000000000,
      m: 1000000,
      k: 1000,
    };
  
    for (const key in abbreviations) {
      if (number >= abbreviations[key]) {
        return (number / abbreviations[key]).toFixed(1) + key;
      }
    }
    return number.toString();
  };
   
  const getArray = () => {
    const currentDate = new Date();
    for (let num = 0; num < 8; num++) {
      const newDate = new Date();
      newDate.setDate(currentDate.getDate() - num);
      const dayToAdd = newDate.getDate();
      const monthToAdd = newDate.getMonth() + 1;
      array.push({value: 0, month: monthToAdd.toString(), day: dayToAdd.toString().padStart(2, '0'),
      });
    }
    return array;
  };

  const fetchedData = async () => {
    getArray()
    DEBUG(true);
    enablePromise(true);
    const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
      tx.executeSql(
        `SELECT DATE(Date) AS day, SUM(Total) AS Total_Value FROM Sales_Items WHERE Date >= DATE('now', '-6 days', '+1 hour') 
        AND Date <= DATETIME('now', 'start of day', '+1 day', '+1 hour', '-1 second') GROUP BY day ORDER BY day DESC;`,
        [],
        (_, results) => {
          const resultRows = results.rows;
          setDateArray([])
          for (let i = 0; i < resultRows.length; i++) {
            const find = resultRows.item(i).day.split('-') [2]
            dataSet.unshift({value: resultRows.item(i).Total_Value, color:colors[i].color});

           array[array.findIndex(item => item.day === resultRows.item(i).day.split('-') [2])].value = resultRows.item(i).Total_Value
            setDateArray(prevStocks => [...prevStocks, resultRows.item(i).day]);
          }
          if (dataSet.length < 7) {
            for (let i = dataSet.length; i < 7; i++) {
              dataSet.push({value:10, color:'gray'})
              setDateArray(prevDateArray => ['', ...prevDateArray]);
            }
        };
        dataSet.length = 0;
        for (let i = 0; i < 7; i++) {
          dataSet.unshift({value: array[i].value, color:colors[i].color});
        }
          setData(dataSet)
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  const receiptTime = {
    someField: 'receiptTime',
    receiptTime: serverTimestamp(),
  };

  const correctDate = async () => {
    try {
      const docRef = await addDoc(collection(getFirestore(), companyDir, branch, 'receipt'), receiptTime);
  
      const documentSnapshot = await getDoc(docRef);
      if (documentSnapshot.exists()) {
        const data = documentSnapshot.data().receiptTime.toDate();
        const date = new Date(data);
        data.setHours(0, 0, 0, 0)
        // const date = new Date(data);
  
        // const day = String(date.getDate()).padStart(2, '0');
        // const month = String(date.getMonth() + 1).padStart(2, '0');
        // const year = date.getFullYear();
        // const hours = String(date.getHours()).padStart(2, '0');
        // const minutes = String(date.getMinutes()).padStart(2, '0');
        // const seconds = String(date.getSeconds()).padStart(2, '0');
        // const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  
        // Delete the document
        await deleteDoc(documentSnapshot.ref);
  
        // Return the formatted date
        return data;
      } else {
        console.log('Document does not exist.');
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  };
  
// Define a function to fetch data
const fetchData = async () => {
  getArray();
  try {
    // Create a reference to the Sales_Items collection
    const salesItemsColRef = collection(getFirestore(), companyDir, branch,  'salesItems');

    // Calculate date ranges
    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);
    
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 6)

    // Create a query to fetch data
    const querySnapshot = await getDocs(
      query(
        salesItemsColRef,
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date'), // Add an orderBy clause for the 'date' field
      )
    );
    
    const dataMap = {};

    querySnapshot.forEach((doc) => {
      const total = doc.data().total;
      const data = doc.data().date.toDate();

      const day = String(data.getDate()).padStart(2, '0');
      const month = String(data.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = data.getFullYear();

      const date = `${day}-${month}-${year}`
    
      if (!dataMap[date]) {
        dataMap[date] = 0;
      }
    
      dataMap[date] += total;
    });

    const sortedDates = Object.keys(dataMap).sort((a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA.getTime() - dateB.getTime();
    });

    for (const date of Object.keys(dataMap)) {
      const day = date.split('-')[0]; // Extract day from the date
      const totalValue = dataMap[date]; // Get the total value for the date
    
      // Find the color based on the index or another method
      const color = colors[Object.keys(dataMap).indexOf(date)].color;
    
      dataSet.unshift({ value: totalValue, color });
      // Assuming you want to set `day` in `array`, use `day` instead of `resultRows.item(i).day.split('-')[2]`
      const dayIndex = array.findIndex(item => item.day === day);
      if (dayIndex !== -1) {
        array[dayIndex].value = totalValue;
      }
      setDateArray(prevStocks => [...prevStocks, day]);
    }
    
    if (dataSet.length < 7) {
      for (let i = dataSet.length; i < 7; i++) {
        dataSet.push({value:10, color:'gray'})
        setDateArray(prevDateArray => ['', ...prevDateArray]);
      }
  };
  dataSet.length = 0;
  for (let i = 0; i < 7; i++) {
    dataSet.unshift({value: array[i].value, color:colors[i].color});
  }
    setData(dataSet)
  } catch (error) {
    console.error('Error fetching data from Firestore', error);
  }
};

  useEffect(() => {
    const usecodes = async() => {
      await correctDate()
        .then((accurateDate) => {
          correctDateTime.unshift(accurateDate);
          fetchData();
        })
    }
    usecodes();
    }, []);
  

    

    const barWidth = 34;
    const maxValue = Math.max(...data.map((item) => item.value));
    const barHeight = useRef(data.map(() => new Animated.Value(0))).current;
    const [highestNumber, setHighestNumber] = useState(0)
    
      useEffect(() => {
        const animateBars = () => {
          const animationPromises = data.map((item, index) => {
            return new Promise((resolve) => {
              Animated.timing(barHeight[index], {
                toValue: item.value,
                duration: 3000,
                useNativeDriver: false,
              }).start(resolve);
            });
          });
    
          Promise.all(animationPromises).then(() => {
          });
        };
        animateBars();
        let highest = data ? Math.max(...data.map((item) => item.value)) : 10
        setHighestNumber(highest)
      }, [data]);

      for (let i = 1; i < 7; i++) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const monthName = monthNames[date.getMonth()];
        yAxisItems.push(
          <Text key={i} style={{ ...styles.yAxisFonts, backgroundColor: 'white' }}>
            {`${ordinalSuffix} ${monthName}`}
          </Text>
        );
      }

      
    return(
        <View style={{backgroundColor:'white', width:410, height:355, borderWidth: brdWdth, borderRadius:10, borderColor:'#DCE3E8', flexDirection:'column-reverse'}}>
            <View style={{flexDirection:'column', marginBottom:20}}>
                <View style={{flexDirection:'row'}}>
                    <View style={{flexDirection:'column', height:200, justifyContent:'space-between' , marginLeft:10, marginTop:1}}>
                        <Text></Text>
                        <Text style={{...styles.xAxisFonts}}> {highestNumber ? '₦' + formatNumber(highestNumber) + '-' : '500-'}</Text>
                        <Text style={styles.xAxisFonts}>-</Text>
                        <Text style={styles.xAxisFonts}>{highestNumber ? '₦' + formatNumber((highestNumber / 5) * 4) + '-' : '400-'}</Text>
                        <Text style={styles.xAxisFonts}>-</Text>
                        <Text style={styles.xAxisFonts}>{highestNumber ? '₦' + formatNumber((highestNumber / 5) * 3) + '-' : '300-'}</Text>
                        <Text style={styles.xAxisFonts}>-</Text>
                        <Text style={styles.xAxisFonts}>{highestNumber ? '₦' + formatNumber((highestNumber / 5) * 2) + '-' : '200-'}</Text>
                        <Text style={styles.xAxisFonts}>-</Text>
                        <Text style={styles.xAxisFonts}>{highestNumber ? '₦' + formatNumber(highestNumber / 5) + '-' : '100-'}</Text>
                        <Text style={styles.xAxisFonts}>-</Text>
                       
                    </View>
                    <View style={{ //barchart curve container
                        height:200, 
                        width:330, 
                        borderTopLeftRadius:0, 
                        borderBottomRightRadius:0, 
                        borderRadius:10, 
                        borderLeftWidth:2, 
                        borderBottomWidth:2, 
                        borderColor:'black',
                        flexDirection:'row',
                        margin:10,
                        marginLeft:0,
                        marginBottom:-5
                    }}>
                        <View style={{width:300, height:178, marginTop:20, marginLeft:-10, flexDirection:'row-reverse', alignItems:'flex-end', justifyContent:'space-between'}}>
                           
                            {data.map((item, index) => (
                                <Animated.View
                                key={index}
                                style={[
                                    styles.bar,
                                    { height: barHeight[index] ?  barHeight[index].interpolate({
                                        inputRange: [0, maxValue],
                                        outputRange: [0, 198], // Adjust the maximum height as needed
                                      }) 
                                      : 
                                      new Animated.Value(10).interpolate({
                                        inputRange: [0, maxValue],
                                        outputRange: [0, 198], // Adjust the maximum height as needed
                                      }),
                                      backgroundColor: item.color,
                                      width: barWidth },
                                ]}
                                />
                            ))}
                        
                        </View>
                    
                    </View>
                </View>
                
                <View style={{flexDirection:'row', width:350, justifyContent:'space-between', marginLeft:39}}>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}></Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                  <Text style={{...styles.textFonts, width:30, textAlign:'center'}}>|</Text>
                        
                </View>
                       
                <View style={{flexDirection:'row', width:350, justifyContent:'space-between', backgroundColor:'white', marginLeft:39}}>
                  <Text style={{...styles.yAxisFonts, backgroundColor:'white'}}></Text>
                  <Text style={{...styles.yAxisFonts, marginLeft:-7, width:42, backgroundColor:'white'}}>Today</Text>
                  {yAxisItems}
                </View>
            </View>
            <Text style={{...styles.headerFont, margin:20, textAlign:'left', fontSize:20, marginBottom:35}}>
              Last 7 days Sales Chart
            </Text>
        </View>
    )
}
const styles = StyleSheet.create({
    xAxisFonts: {
      color:'#2a2d3e', 
      fontFamily:'century gothic', 
      fontSize:14, 
      fontWeight:'normal',
      textAlign:'right',
      marginLeft:-7,
      width:64,
      height:18,
      justifyContent:'center'

    },
    yAxisFonts: {
      color:'#2a2d3e', 
      fontFamily:'century gothic', 
      fontSize:14, 
      fontWeight:'normal',
      width:35, 
      textAlign:'center', 
      marginTop:-8,
  },
    textFonts: {
      color:'#2a2d3e', 
      fontFamily:'century gothic', 
      fontSize:14, 
      fontWeight:'normal',
      textAlign:'right',
  },
    headerFont: {
      color:'#2a2d3e', 
      fontFamily:'century gothic', 
      fontSize:14, 
      fontWeight:'normal',
      textAlign:'right',
      
  },
    bar: {
      marginLeft: 20,
      borderRadius: 5,
      marginHorizontal: -30,
      borderBottomLeftRadius:0,
      borderBottomRightRadius:0,
    },
  });
export default AdvancedCustomBar